import React, { useState } from "react";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import Myntra      from "../../Assets/Projects/Myntra.png";
import PrintForge  from "../../Assets/Projects/PrintForge.png";
import Shop        from "../../Assets/Projects/real_estate.png";
import image       from "../../Assets/Projects/image.png";
import muaaz_mart  from "../../Assets/Projects/Muaaz_mart.png";
import Pizza       from "../../Assets/Projects/Pizza.png";
import Xcode       from "../../Assets/Projects/4xcode.png";
import skillFordge from "../../Assets/Projects/skillfordge.webp";

const PROJECTS = [
  { id:1, img: muaaz_mart,  title:"Muaaz's Mart – Full-Stack E-Commerce",    desc:"Full-stack e-commerce platform with real-time chat (Socket.io), secure auth, and a responsive UI.",                                gh:"https://github.com/MuhammadMuaaz007/E-Shop",              demo:"https://e-shop-frontend1.vercel.app/" },
  { id:2, img: skillFordge, title:"LMS Web Application",                    desc:"Learning Management System with Next.js, TypeScript, Redis, JWT auth, role-based access, and video-based learning.",               gh:"https://github.com/MuhammadMuaaz007/LMS-WEB-APPLICATION", demo:"https://lms-web-application-3opu.vercel.app/" },
  { id:3, img: Xcode,       title:"4xCode – Company Website",               desc:"Sleek, highly responsive corporate website with modern UI and optimised performance.",                                              gh:"",                                                         demo:"https://www.4xcode.com/" },
  { id:4, img: image,       title:"Edusity – Education Platform",           desc:"Responsive education platform UI using React with reusable components and smooth navigation.",                                     gh:"https://github.com/MuhammadMuaaz007/Edusity",             demo:"https://edusity-muaaz.vercel.app/" },
  { id:5, img: Shop,        title:"Home Hub – Full-Stack Real Estate App",  desc:"Full-stack real estate app for listing and discovering properties with secure backend APIs.",                                      gh:"https://github.com/MuhammadMuaaz007/mern-estate",         demo:"https://home-hub-seven.vercel.app/" },
  { id:6, img: Myntra,      title:"Myntra Clone",                           desc:"Frontend e-commerce clone recreating product browsing, responsive navigation, and polished UI.",                                   gh:"https://github.com/MuhammadMuaaz007/MyntraBasicClone",    demo:"https://myntra-muaaz.vercel.app/" },
  { id:7, img: PrintForge,  title:"PrintForge – 3D Models Marketplace",     desc:"Next.js + TypeScript + Tailwind app for browsing 3D models with optimised routing and fast performance.",                         gh:"https://github.com/MuhammadMuaaz007/PrintForge",          demo:"https://print-forge-web.vercel.app/" },
  { id:8, img: Pizza,       title:"Next Pizza Shop",                        desc:"Modern pizza ordering app with product browsing, cart & checkout flows, built with Next.js.",                                     gh:"https://github.com/MuhammadMuaaz007/next-pizza-shop",     demo:"https://next-pizza-shop-seven.vercel.app/" },
];

const PER_PAGE = 6;

function ProjectsSection() {
  const [page, setPage] = useState(1);
  const total = Math.ceil(PROJECTS.length / PER_PAGE);
  const slice = PROJECTS.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  function changePage(p) {
    setPage(p);
    document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <section id="projects" className="portfolio-section">
      <div className="section-container">
        <span className="section-label">Portfolio</span>
        <h2 className="section-title">My Recent <span>Works</span></h2>
        <p className="section-subtitle">A selection of projects I've built recently.</p>
        <div className="section-divider" />

        <div className="projects-grid">
          {slice.map((p) => (
            <div className="project-card" key={p.id}>
              <div className="project-img-wrap">
                <img src={p.img} alt={p.title} className="project-img" />
                <div className="project-img-overlay" />
              </div>
              <div className="project-body">
                <h3 className="project-title">{p.title}</h3>
                <p className="project-desc">{p.desc}</p>
                <div className="project-actions">
                  {p.gh && (
                    <a href={p.gh} target="_blank" rel="noreferrer" className="proj-btn proj-btn-primary">
                      <BsGithub /> GitHub
                    </a>
                  )}
                  {p.demo && (
                    <a href={p.demo} target="_blank" rel="noreferrer" className="proj-btn proj-btn-outline">
                      <CgWebsite /> Live Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {total > 1 && (
          <div className="projects-pagination">
            <button className="proj-page-btn nav-btn" disabled={page === 1} onClick={() => changePage(page - 1)}>← Prev</button>
            {Array.from({ length: total }, (_, i) => i + 1).map((n) => (
              <button key={n} className={`proj-page-btn${page === n ? " active" : ""}`} onClick={() => changePage(n)}>{n}</button>
            ))}
            <button className="proj-page-btn nav-btn" disabled={page === total} onClick={() => changePage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
    </section>
  );
}

export default ProjectsSection;
